import { render, staticRenderFns } from "./testResults.vue?vue&type=template&id=9171f91a&scoped=true&"
import script from "./testResults.js?vue&type=script&lang=js&"
export * from "./testResults.js?vue&type=script&lang=js&"
import style0 from "./testResults.vue?vue&type=style&index=0&id=9171f91a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9171f91a",
  null
  
)

export default component.exports